import type { SVGProps } from 'react';

export const SvgIconCategory200 = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.875 13.625H23.875" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9.875 13.625H13.875" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11.875 11.625V15.625" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M22.376 7.08594L11.376 7.12344C9.84822 7.12634 8.37005 7.66631 7.2001 8.64889C6.03015 9.63147 5.24289 10.9941 4.97604 12.4984V12.4984L2.92604 23.0109C2.79441 23.7451 2.90073 24.502 3.22949 25.1715C3.55826 25.8409 4.09227 26.3878 4.75368 26.7325C5.41509 27.0772 6.1693 27.2015 6.90635 27.0875C7.6434 26.9734 8.32474 26.6269 8.85104 26.0984V26.0984L14.251 20.1234L22.376 20.0859C24.0999 20.0859 25.7532 19.4011 26.9722 18.1821C28.1912 16.9631 28.876 15.3098 28.876 13.5859C28.876 11.862 28.1912 10.2087 26.9722 8.98974C25.7532 7.77076 24.0999 7.08594 22.376 7.08594V7.08594Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.775 12.4609L30.825 23.0109C30.9566 23.7451 30.8503 24.502 30.5215 25.1715C30.1928 25.8409 29.6588 26.3878 28.9974 26.7325C28.3359 27.0772 27.5817 27.2015 26.8447 27.0875C26.1076 26.9734 25.4263 26.6269 24.9 26.0984V26.0984L19.5 20.0984"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
